import { combineReducers } from 'redux';
import auth from './auth';
import station from './station';
import loading from './loading';
import brands from './brands';
import dateRange from './date-range';
import comparisonMetric from './comparison-metric';

export { Action } from '../actions';

export default combineReducers({
  auth,
  station,
  loading,
  brands,
  dateRange,
  comparisonMetric,
});
